export default __webpack_public_path__ + "static/media/hassan5.ff62e8db.JPG";